import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../../../context/AppContext';

const TopProducts = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [topProducts, setTopProducts] = useState([]);

 // NEW
  useEffect(() => {
    fetch(`${baseUrl}/admin/top-products`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
        Accept: 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setTopProducts(Array.isArray(data) ? data : []))
      .catch(() => setTopProducts([]));
  }, []);

  const handleViewAll = () => {
    navigate('/admin/product-management');
  };

  return (
    <div className="AdminSideDashboard__productsSection AdminSideDashboard--slideUp" style={{ animationDelay: '0.6s' }}>
      <h2 className="AdminSideDashboard__sectionTitle">Top Selling Products</h2>
      
      <div className="AdminSideDashboard__productsList">
        {topProducts.map((product, index) => (
          <div 
            key={product.id} 
            className="AdminSideDashboard__productItem AdminSideDashboard--fadeInUp"
            style={{ animationDelay: `${0.1 * index}s` }}
          >
            <img 
              src={`${baseUrlForFiles}/${product.image}`} 
              alt={product.name}
              className="AdminSideDashboard__productImage"
            />
            <div className="AdminSideDashboard__productInfo">
              <div className="AdminSideDashboard__productName">{product.name}</div>
              <div className="AdminSideDashboard__productCategory">{product.category}</div>
            </div>
            <div className="AdminSideDashboard__productStats">
              <div className="AdminSideDashboard__productPrice">Rs {Number(product.price).toLocaleString()}</div>
              <div className="AdminSideDashboard__productSold">{product.sold} sold</div>
            </div>
          </div>
        ))}
      </div>
      
      <button 
        className="AdminSideDashboard__viewAllBtn"
        onClick={handleViewAll}
      >
        View All Products
      </button>
    </div>
  );
};

export default TopProducts;